import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import ChartTitle from '../../../../../elements/ChartTitle';
import NoDataAvailable from '../NoDataAvailable';
import { Spinner } from 'react-bootstrap';
import { coloursArray } from '../../../../../../lib/utils';

const SprintPredictabilityChart = ({ data, loading, isJiraIntegrated }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (!data?.length) {
      setChartData([]);
      return;
    }

    const processed = data.map((sprint, index) => {
      const committed = sprint.totalStoryPoints || 0;
      const completed = sprint.completedStoryPoints || 0;
      const predictability = committed > 0 ? (completed / committed) * 100 : 0;

      return {
        sprint: sprint.sprintName || 'Unknown Sprint',
        committed,
        completed,
        predictability: +predictability.toFixed(2),
        fill: coloursArray[index % coloursArray.length],
      };
    });

    setChartData(processed);
  }, [data]);

  return (
    <div className="chart-div">
      <ChartTitle title="Predictability" showWarning={!isJiraIntegrated} />
      {loading ? (
        <Spinner className="mt-5" />
      ) : chartData.length === 0 ? (
        <NoDataAvailable />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={chartData}
            barSize={30}
            margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="sprint" tick={{ fontSize: 12 }} />
            <YAxis unit="%" domain={[0, 100]} />
            <Tooltip formatter={(value, name) => [`${Math.round(value)}%`, name]} />
            <Bar
              dataKey="predictability"
              name="Predictability"
              fill={(entry) => entry.fill}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default SprintPredictabilityChart;
